// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7e500472","455":"5d385f58","977":"4c750757"}[chunkId] + ".chunk.js";
};